import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/hooks'
import Slide from 'components/misc/Slide'
import { clearFilter } from 'store/search/actions'
import { selectSearchPills } from 'store/search/selectors'
import { XIcon } from 'components/icons/Icon'

import styles from './styles/SearchPills.css'

interface SearchPill {
  stateKey: string
  label: string
  value: string
}

const Pill = ({ stateKey, label, value }: SearchPill) => {
  const dispatch = useDispatch()

  const [moused, setMoused] = useState(false)

  const handleMouseEnter = () => setMoused(true)
  const handleMouseLeave = () => setMoused(false)
  const handleClick = () => setMoused(!moused)

  return (
    <div className={styles.pill} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {value}
        <Slide className={styles.close} show={moused} direction='right'>
          <button
            type='button'
            className={styles.closeButton}
            aria-label={`Remove ${label} filter`}
            onClick={() => dispatch(clearFilter(stateKey))}
          >
            <XIcon className={styles.closeIcon} size='1em' aria-hidden='true' />
          </button>
        </Slide>
      </span>
    </div>
  )
}

export const SearchPills = () => {
  // store/search is still JS, and its selector reads the pill's value as `{}`.
  const searchPills = useSelector(({ search }) => selectSearchPills(search)) as SearchPill[]

  return (
    <div>
      {searchPills.map(pill => (
        <Pill key={pill.stateKey} {...pill} />
      ))}
    </div>
  )
}

export default SearchPills
